import { useEffect } from 'react';
import { getConsent } from './CookieConsent';

/**
 * Loads Plausible Analytics script after the user has consented to "analytics".
 * Plausible itself is cookie-free, but we still respect the user's choice.
 *
 * Configure via .env:
 *   REACT_APP_PLAUSIBLE_DOMAIN=kanzlei-partner.com
 *   REACT_APP_PLAUSIBLE_SRC=https://plausible.io/js/script.js   (optional, default)
 */
const PlausibleAnalytics = () => {
  useEffect(() => {
    const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    if (!domain) return;
    const src = process.env.REACT_APP_PLAUSIBLE_SRC || 'https://plausible.io/js/script.js';

    const inject = () => {
      if (document.querySelector('script[data-plausible="1"]')) return;
      const s = document.createElement('script');
      s.defer = true;
      s.dataset.domain = domain;
      s.dataset.plausible = '1';
      s.src = src;
      document.head.appendChild(s);
    };

    const consent = getConsent();
    if (consent?.analytics) inject();

    const onConsent = (e) => {
      if (e.detail?.analytics) inject();
    };
    window.addEventListener('kp:consent', onConsent);
    return () => window.removeEventListener('kp:consent', onConsent);
  }, []);

  return null;
};

export default PlausibleAnalytics;
